/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from 'react';
import {
  VegaTabGroup,
  VegaButtonLink
} from '@heartlandone/vega-react';
import MessageTabGroupPanel from './MessageTabGroupPanel';
import { useDispatch } from 'react-redux';
import { initializeMessageState, notifyMessagesUpdated } from 'Slices/Header/messageSlice';
import { getMessageCounts } from 'Chores/request';
import { getUserInfo } from 'Chores/utils';
import { useKeycloak } from '@react-keycloak/web';

const MessageTabGroup = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const userInfo = getUserInfo(keycloak?.idTokenParsed?.sub);
  const userId = userInfo?.userId || userInfo?.id || '';
  const [selectedTab, setSelectedTab] = useState('allLists');
  const [counts, setCounts] = useState({ unreadCount: 0, systemUnreadCount: 0 });

  const refreshCounts = useCallback(async () => {
    if (!userId) {
      setCounts({ unreadCount: 0, systemUnreadCount: 0 });
      return;
    }
    try {
      const response = await getMessageCounts(userId);
      setCounts({
        unreadCount: response?.unreadCount || 0,
        systemUnreadCount: response?.systemUnreadCount || 0
      });
      dispatch(notifyMessagesUpdated());
    } catch (error) {
      setCounts({ unreadCount: 0, systemUnreadCount: 0 });
    }
  }, [userId, dispatch]);

  useEffect(() => {
    refreshCounts();
  }, [refreshCounts]);

  const goBack = () => {
    window.history.back();
  };

  const tabItems = [
    {
      label: 'All Messages',
      dataTarget: 'allLists',
      counterBadge: { color: `bg-action`, count: counts.unreadCount }
    },
    {
      label: 'Unread',
      dataTarget: 'unread',
      counterBadge: { color: `bg-action`, count: counts.unreadCount }
    },
    {
      label: 'System',
      dataTarget: 'system',
      counterBadge: { color: `bg-action`, count: counts.systemUnreadCount }
    }];

  const initializeState = (e) => {
    const newTab = e.detail;
    setSelectedTab(newTab);
    dispatch(initializeMessageState());
  };

  return (
    <>
      <VegaButtonLink icon="fas fa-angle-left" onVegaClick={goBack}>
        Back
      </VegaButtonLink>
      <VegaTabGroup
        tabItems={tabItems}
        selectedTabDataTarget={selectedTab}
        id="message-tab-group"
        onVegaClick={initializeState}
      >
        {tabItems.map((item) =>
          <MessageTabGroupPanel
            key={item.dataTarget}
            item={item}
            userId={userId}
            selectedTab={selectedTab}
            refreshCounts={refreshCounts}
          />)}
      </VegaTabGroup>
    </>
  );
};

MessageTabGroup.propTypes = {};

export default MessageTabGroup;
